import React from 'react';
import * as Styles from './pricing.styled';
import { truncatedZeroPencePrice } from '@at/formatter-utils/lib/number-utils/number.utils';
import { PriceIndicatorPill } from '@at/design-system-elements';
export var PricingUsed = function (_a) {
    var price = _a.price, priceIndicatorRating = _a.priceIndicatorRating, priceIndicatorRatingLabel = _a.priceIndicatorRatingLabel;
    var displayPrice = price && typeof price === 'number' ? truncatedZeroPencePrice(price) : price;
    return (React.createElement(React.Fragment, null,
        displayPrice && React.createElement(Styles.VehicleCardDisplayPrice, null, displayPrice),
        priceIndicatorRatingLabel && priceIndicatorRating && (React.createElement(Styles.VehicleCardBadgeGroup, null,
            React.createElement(PriceIndicatorPill, { text: priceIndicatorRatingLabel, priceIndicatorRating: priceIndicatorRating })))));
};
